// extracted by mini-css-extract-plugin
export var alertIcon = "_rv-0";